var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotographyVideography(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2851 0.378413C53.1151 0.288413 51.9351 0.248413 50.7451 0.248413C23.1351 0.248413 0.745132 22.6384 0.745132 50.2484C0.745132 77.8584 23.1351 100.248 50.7451 100.248C72.3051 100.248 90.6751 86.5984 97.6951 67.4784C99.6651 62.1084 100.745 56.2984 100.745 50.2484C100.745 23.8284 80.2451 2.18841 54.2851 0.378413ZM90.8151 68.4284C83.8751 83.6484 68.5251 94.2484 50.7451 94.2484C26.4851 94.2484 6.74513 74.5084 6.74513 50.2484C6.74513 42.7784 8.61513 35.7484 11.9151 29.5784C19.3251 15.7084 33.9551 6.24841 50.7451 6.24841C75.0051 6.24841 94.7451 25.9884 94.7451 50.2484C94.7451 56.7284 93.3351 62.8884 90.8151 68.4284Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5151 31.9984C48.5651 31.9984 42.9151 37.6484 42.9151 44.5984C42.9151 51.5484 48.5651 57.1984 55.5151 57.1984C62.4651 57.1984 68.1151 51.5484 68.1151 44.5984C68.1151 37.6484 62.4651 31.9984 55.5151 31.9984ZM55.5151 54.8984C49.8451 54.8984 45.2251 50.2784 45.2251 44.6084C45.2251 38.9384 49.8451 34.3184 55.5151 34.3184C61.1851 34.3184 65.8051 38.9384 65.8051 44.6084C65.8051 50.2784 61.1851 54.8984 55.5151 54.8984Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5151 36.0584C54.8751 36.0584 54.3551 36.5784 54.3551 37.2184C54.3551 37.8584 54.8751 38.3784 55.5151 38.3784C58.9551 38.3784 61.7551 41.1784 61.7551 44.6184C61.7551 45.2584 62.2751 45.7784 62.9151 45.7784C63.5551 45.7784 64.0751 45.2584 64.0751 44.6184C64.0751 39.9084 60.2451 36.0684 55.5251 36.0684L55.5151 36.0584Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5751 18.2384C61.8751 16.7484 60.3851 15.7884 58.7351 15.7884H52.0551C50.4051 15.7884 48.9151 16.7384 48.2151 18.2384L45.7951 23.4184H64.9851L62.5651 18.2384H62.5751Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6851 22.3584C34.6851 20.6484 33.2951 19.2584 31.5851 19.2584H29.3251C27.6151 19.2584 26.2251 20.6484 26.2251 22.3584V23.4284H34.6851V22.3584Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0551 74.5584H44.8551V66.3784H38.8651V84.7084H44.8551V76.3384H66.0551V84.7084H72.1651V66.3784H66.0551V74.5584ZM43.1351 83.4484H40.6451V80.9584H43.1351V83.4484ZM43.1351 79.1784H40.6451V76.6884H43.1351V79.1784ZM43.1351 74.9084H40.6451V72.4184H43.1351V74.9084ZM43.1351 70.6384H40.6451V68.1484H43.1351V70.6384ZM67.8851 68.1484H70.3751V70.6384H67.8851V68.1484ZM67.8851 72.4184H70.3751V74.9084H67.8851V72.4184ZM67.8851 76.6884H70.3751V79.1784H67.8851V76.6884ZM67.8851 80.9584H70.3751V83.4484H67.8851V80.9584Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4851 34.3084H18.9851V57.6984C18.9851 60.7184 21.4351 63.1684 24.4551 63.1684H30.9151V39.7484C30.9151 36.7484 28.4751 34.3084 25.4851 34.3084Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0351 25.5684H24.4751C21.4551 25.5684 19.0051 28.0184 19.0051 31.0384V32.0084H25.4951C29.7651 32.0084 33.2351 35.4784 33.2351 39.7484V63.1584H77.0251C80.0451 63.1584 82.4951 60.7084 82.4951 57.6884V31.0284C82.4951 28.0084 80.0451 25.5584 77.0251 25.5584L77.0351 25.5684ZM55.3951 59.5884C47.1151 59.5884 40.4151 52.8784 40.4151 44.6084C40.4151 36.3384 47.1251 29.6284 55.3951 29.6284C63.6651 29.6284 70.3751 36.3384 70.3751 44.6084C70.3751 52.8784 63.6651 59.5884 55.3951 59.5884ZM76.2351 34.5784C74.7251 34.5784 73.5051 33.3584 73.5051 31.8484C73.5051 30.3384 74.7251 29.1184 76.2351 29.1184C77.7451 29.1184 78.9651 30.3384 78.9651 31.8484C78.9651 33.3584 77.7451 34.5784 76.2351 34.5784Z",
    fill: "#FF4D6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1698",
    x: -0.00000339746,
    y: 0.0000344813,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1698"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1698",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1698"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1698",
    result: "effect3_innerShadow_4857_1698"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotographyVideography);
export default __webpack_public_path__ + "static/media/PhotographyVideography.bf341667ecbc3bad1028028a6f820240.svg";
export { ForwardRef as ReactComponent };